import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { Site } from '@datadog/browser-core/cjs/domain/intakeSites';
import { useEffect } from 'react';
import { useUserProfile } from '@backstage/plugin-user-settings';

import { configApiRef, useApi } from '@backstage/core-plugin-api';

function useSetupDatadogRum() {
  const configApi = useApi(configApiRef);
  const env = configApi.getOptionalString('app.datadogRum.env');
  const {
    profile: { displayName, email },
  } = useUserProfile();

  useEffect(() => {
    if (email && env !== 'locals' && !datadogRum.getInitConfiguration()) {
      datadogRum.init({
        applicationId: configApi.getOptionalString(
          'app.datadogRum.applicationId',
        )!,
        clientToken: configApi.getOptionalString('app.datadogRum.clientToken')!,
        site: configApi.getOptionalString('app.datadogRum.site') as Site,
        service: 'backstage',
        env: configApi.getOptionalString('app.datadogRum.env'),
        version: configApi.getOptionalString('app.datadogRum.version'),
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        plugins: [reactPlugin()],
      });

      datadogRum.setUser({
        id: email,
        name: displayName,
        email,
      });
    }
  }, [configApi, displayName, email, env]);
}

export { useSetupDatadogRum };
